export default __webpack_public_path__ + "media/images/home/slide_new_plan_2025_lg-b4dfaec8c5a8c21f116e1e1cb65b55cb.jpg";